import React, { Component } from "react";
import alert from "ui.bambora/dist/svg/alert.svg";
import amex from "ui.bambora/dist/svg/amex.svg";
import arrowLeft from "ui.bambora/dist/svg/arrow-left.svg";
import clock from "ui.bambora/dist/svg/clock.svg";
import close from "ui.bambora/dist/svg/close.svg";
import closeThin from "ui.bambora/dist/svg/close-thin.svg";
import comment from "ui.bambora/dist/svg/comment.svg";
import creditcardOutline from "ui.bambora/dist/svg/creditcard-outline.svg";
import denied from "ui.bambora/dist/svg/denied.svg";
import download from "ui.bambora/dist/svg/download.svg";
import flag from "ui.bambora/dist/svg/flag.svg";
import list from "ui.bambora/dist/svg/list.svg";
import mastercard from "ui.bambora/dist/svg/mastercard.svg";
import more from "ui.bambora/dist/svg/more.svg";
import notificationActive from "ui.bambora/dist/svg/notification-active.svg";
import notificationInactive from "ui.bambora/dist/svg/notification-inactive.svg";
import reload from "ui.bambora/dist/svg/reload.svg";
import search from "ui.bambora/dist/svg/search.svg";
import visa from "ui.bambora/dist/svg/visa.svg";
import unionpay from "ui.bambora/dist/svg/unionpay.svg";

class BamboraSvgIcon extends Component {
  constructor(props) {
    super(props);
  }
  // takes an icon and a fill color
  render() {
    var namedIcons = {
      alert: alert,
      amex: amex,
      "arrow-left": arrowLeft,
      clock: clock,
      close: close,
      "close-thin": closeThin,
      comment: comment,
      "creditcard-outline": creditcardOutline,
      denied: denied,
      download: download,
      flag: flag,
      list: list,
      mastercard: mastercard,
      more: more,
      "notification-active": notificationActive,
      "notification-inactive": notificationInactive,
      reload: reload,
      search: search,
      visa: visa,
      unionpay: unionpay,
    };
    var classNamesConcat = this.props.classNames instanceof Array ? this.props.classNames.join(" ") : "";
    var classNameValue = this.props.className ? this.props.className : classNamesConcat;
    classNameValue += " svg-icon";
    var iconMarkup = { __html: namedIcons[this.props.icon] || "" };

    return <div className={classNameValue} dangerouslySetInnerHTML={iconMarkup}></div>;
  }
}

export default BamboraSvgIcon;
